<template>
    <div v-if="indicator" class="p-relative">

        <Toolbar v-on:toolbar-button-click="onToolbarClick" />
        
        <DocumentPanel :document-info="dataSource.Data.Object" />

        <v-tabs
            v-model="tab"
            background-color="transparent"
            slider-size="3"
            class="tab-selector-panel"
        >
            <v-tabs-slider color="#E43958"></v-tabs-slider>

            <v-tab 
                v-for="item in pages"
                :key="item.FormId"
                @click="onTabClicked(item.FormId)"
            >
                <template v-if="item.Count < 0">
                    {{ item.Name }}
                </template>
                <template v-else>
                    {{ item.Name }}
                    <span class="count" id="attachCounter">{{ item.Count }}</span>
                </template>   
            </v-tab>

        </v-tabs>

        <v-tabs-items
            v-model="tab"
            class="tab-content-panel"
        >
        
            <v-tab-item 
                v-for="item in pages"
                :key="item.FormId"
            >
                <!-- Карточка -->
                <template v-if="item.FormId == indicator.id">
                    <v-form class="wrapperForm" ref="form1" lazy-validation>
                        <v-row dense>
                            
                            <!-- Основная информация -->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                <v-card-panel title="Основная_информация">
                                    
                                    <!--поле Категория-->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Категория")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{indicator.CategoryId ? indicator.CategoryId : $t("не_указано")}}
                                            </div>
                                            <v-select
                                                v-else
                                                :value="indicator.CategoryId"
                                                @input="update({ property: 'Data.Object.CategoryId', value: $event})"
                                                :items="[]"
                                                item-value="id"
                                                item-text="name"
                                                hide-details
                                                required
                                                outlined
                                                dense
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <!--поле Родительский индикатор-->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Родительский_индикатор")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{availableParentIndicators.find(ap => ap.Id == indicator.ParentId)?.Name ?? $t("Отсутствует")}}
                                            </div>
                                            <v-select
                                                v-else
                                                :value="indicator.ParentId"
                                                @input="update({ property: 'Data.Object.ParentId', value: $event})"
                                                :items="availableParentIndicators"
                                                item-value="Id"
                                                item-text="Name"
                                                hide-details
                                                required
                                                outlined
                                                dense
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                            >
                                                <template v-slot:prepend-item>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-text-field 
                                                                :placeholder="$t('Поиск')"
                                                                class="mb-2 autocomplete-search"
                                                                hide-details
                                                                dense
                                                                clearable
                                                                autofocus
                                                                v-model="indicatorsSearch"
                                                            >
                                                            </v-text-field>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <!-- Наименование -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Наименование")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{indicator.Name}}
                                            </div>
                                            <template v-else>
                                                <v-text-field
                                                    :value="indicator.Name"
                                                    @input="update({ property: 'Data.Object.Name', value: $event})"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </template>
                                        </v-col>
                                    </v-row>

                                    <!-- Описание -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Описание")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{indicator.Description}}
                                                </div>
                                                <v-textarea v-else
                                                    :value="indicator.Description"
                                                    @input="update({ property: 'Data.Object.Description', value: $event})"
                                                    rows="3"
                                                    no-resize
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-textarea>
                                            </v-col>
                                    </v-row>

                                    <!-- Единица_измерения -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Единица_измерения")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{indicator.Measure}}
                                            </div>
                                            <template v-else>
                                                <v-text-field
                                                    :value="indicator.Measure"
                                                    @input="update({ property: 'Data.Object.Measure', value: $event})"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </template>
                                        </v-col>
                                    </v-row>

                                </v-card-panel>
                            </v-col>

                            <!-- ??? -->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                <v-card-panel title="???">

                                    <!-- Дата начала -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Дата_начала")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{$moment(indicatorStartDate).format('DD.MM.YYYY')}}
                                            </div>
                                            <template v-else>
                                                <v-menu 
                                                    v-model="startDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="indicatorStartDate | formattedDate"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on" 
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            :rules="requiredRule"
                                                            class="datepick-input"
                                                        >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker
                                                        v-model="indicatorStartDate"
                                                        @input="startDateMenu = false"
                                                        color="teal"
                                                        :first-day-of-week="1"
                                                        :max="indicatorTargetDate ? $moment(indicatorTargetDate).add(-1, 'd').format('YYYY-MM-DD') : null"
                                                    >
                                                    </v-date-picker>
                                                </v-menu>
                                            </template>
                                        </v-col>
                                    </v-row>

                                    <!-- Дата завершения -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Дата_завершения")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{$moment(indicatorTargetDate).format('DD.MM.YYYY')}}
                                            </div>
                                            <template v-else>
                                                <v-menu 
                                                    v-model="targetDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="indicatorTargetDate | formattedDate"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on" 
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            :rules="requiredRule"
                                                            class="datepick-input"
                                                        >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker
                                                        v-model="indicatorTargetDate"
                                                        @input="targetDateMenu = false"
                                                        color="teal"
                                                        :first-day-of-week="1"
                                                        :min="indicatorStartDate ? $moment(indicatorStartDate).add(1, 'd').format('YYYY-MM-DD') : null"
                                                    >
                                                    </v-date-picker>
                                                </v-menu>
                                            </template>
                                        </v-col>
                                    </v-row>

                                </v-card-panel>
                            </v-col>

                            <!-- Значения -->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                <v-card-panel title="Значения">
                                    
                                    <!--поле Автоплан-->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Автоплан")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ indicator.IsPlanAutoCalculated ? $t("Да") : $t("Нет") }}
                                            </div>
                                            <v-switch
                                                v-else
                                                :input-value="indicator.IsPlanAutoCalculated"
                                                @change="updateSource({ property: 'Data.Object.IsPlanAutoCalculated', value: $event})"
                                                inset
                                                hide-details
                                                class="cust-switch"
                                            />
                                        </v-col>
                                    </v-row>

                                    <!-- Начальное значение -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Начальное_значение")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{getViewValueByMask(indicator.StartValue)}}
                                            </div>
                                            <template v-else>
                                                <v-text-field
                                                    :value="getViewValueByMask(indicator.StartValue)"
                                                    @input.native="updateUnmaskedValue('Data.Object.StartValue', $event)"
                                                    v-facade="valuesMask"
                                                    hide-details
                                                    outlined
                                                    dense
                                                    required
                                                    :rules="stringInteger64Rule"
                                                >
                                                </v-text-field>
                                            </template>
                                        </v-col>
                                    </v-row>

                                    <!-- Планируемое_значение -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Планируемое_значение")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{getViewValueByMask(indicator.TargetValue)}}
                                            </div>
                                            <template v-else>
                                                <v-text-field
                                                    :value="getViewValueByMask(indicator.TargetValue)"
                                                    @input.native="updateUnmaskedValue('Data.Object.TargetValue', $event)"
                                                    v-facade="valuesMask"
                                                    hide-details
                                                    outlined
                                                    dense
                                                    required
                                                    :rules="stringInteger64NotNullRule"
                                                >
                                                </v-text-field>
                                            </template>
                                        </v-col>
                                    </v-row>
                                    
                                    <!-- Текущее значение -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Текущее_значение")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div class="onlyReadData">
                                                {{getViewValueByMask(indicator.CurrentValue)}}
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <!-- Формат числа -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Формат_числа")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{scales.find(x => x.id == indicator.Scale)?.Name ?? $t("Не_указано")}}
                                            </div>
                                            <template v-else>
                                                <v-select
                                                    :value="indicator.Scale"
                                                    @input="update({ property: 'Data.Object.Scale', value: $event})"
                                                    :items="scales"
                                                    item-value="id"
                                                    item-text="Name"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                </v-select>
                                            </template>
                                        </v-col>
                                    </v-row>

                                    <!--поле Тип вычисления-->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Тип_вычисления")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{calculationTypes.find(x => x.id == indicator.CalculationType)?.Name ?? $t("Не_указано")}}
                                            </div>
                                            <v-select
                                                v-else
                                                :value="indicator.CalculationType"
                                                @input="update({ property: 'Data.Object.CalculationType', value: $event})"
                                                :items="calculationTypes"
                                                item-value="id"
                                                item-text="Name"
                                                :item-disabled="item => item.id == 1 && indicator.StartValue > indicator.TargetValue"
                                                hide-details
                                                outlined
                                                dense
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                                required
                                                :rules="integerNotNull"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                </v-card-panel>
                            </v-col>

                        </v-row>
                    </v-form>
                </template>

                <template v-if="item.FormId == 'Periods'">
                    <v-form class="wrapperForm" ref="form2" lazy-validation>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12" class="section-wrapper">
                                <v-card flat>
                                    <v-card-text>
                                        <v-row dense>
                                            <v-col v-for="(period, index) in allPeriods" :key="index" cols="12" sm="4" md="1">
                                                
                                                <div class="form-box-title" :style="period.Disabled ? 'color: gray; border-bottom: 2px solid gray' : ''">{{ months[period.Period - 1] }}</div>

                                                <v-row no-gutters>
                                                    <v-col cols="12" sm="12" md="12">
                                                        <div v-if="isViewMode" class="onlyReadData">
                                                            {{$t("План")}}: {{getViewValueByMask(period.Plan)}}
                                                        </div>
                                                        <v-text-field
                                                            v-else
                                                            :label='$t("План")'
                                                            :value="getViewValueByMask(period.Plan)"
                                                            @input.native="updatePeriodUnmaskedValue(index, 'Plan', $event)"
                                                            v-facade="valuesMask"
                                                            persistent-placeholder
                                                            hide-details
                                                            outlined
                                                            dense
                                                            required
                                                            :rules="period.Disabled ? [] : stringInteger64Rule"
                                                            :disabled="period.Disabled || indicator.IsPlanAutoCalculated"
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row v-if="!indicator.is_new_record" no-gutters>
                                                    <v-col cols="12" sm="12" md="12">
                                                        <div v-if="isViewMode" class="onlyReadData">
                                                            {{$t("Факт")}}: {{getViewValueByMask(period.Fact)}}
                                                        </div>
                                                        <v-text-field
                                                            v-else
                                                            :label='$t("Факт")'
                                                            :value="getViewValueByMask(period.Fact)"
                                                            @input.native="updatePeriodUnmaskedValue(index, 'Fact', $event)"
                                                            v-facade="valuesMask"
                                                            persistent-placeholder
                                                            hide-details
                                                            outlined
                                                            dense
                                                            required
                                                            :rules="period.Disabled ? [] : stringInteger64Rule"
                                                            :disabled="period.Disabled || period.Plan === 0"
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                                    
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" class="section-wrapper">
                                <v-card flat>
                                    <v-card-text>
                                        <v-row dense>
                                            <v-col cols="12" sm="12" md="12">
                                                <div class="form-box-title">График</div>
                                                <div class="chart-container" style="position: relative; height: 400px; width: 100%;">
                                                    <line-chart 
                                                        :chart-data="datacollectionPlanFact" 
                                                        :options="chartOptionsPlanFact" 
                                                        :height="null" 
                                                        :width="null" 
                                                        style="height: 100%; width: 100%;">
                                                    </line-chart>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-form>  
                </template>
                
            </v-tab-item>
        </v-tabs-items>

    </div>
</template>

<script>
const LineChart = {
    extends: Line,
    mixins: [mixins.reactiveProp],
    props: ['options'],
    mounted() {
        this.addPlugin(ChartDataLabels);
        this.renderChart(this.chartData, this.options);
    }
}
import { Line, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import _ from 'lodash';
import sys from '@/services/system';
import { mapActions, mapGetters } from 'vuex';

import Toolbar from '@/components/documents/Toolbar.vue';
import DocumentPanel from '@/components/documents/DocumentPanel.vue';

export default {
    name: "IndicatorCard",
    components: {
        Toolbar,
        DocumentPanel,
        LineChart
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    computed: {
        ...mapGetters({ 
            requiredRule: 'getRequiredRule',
            integerRule: 'getIntegerRule',
            integerNotNull: 'getIntegerNotNullRule',
            stringInteger64Rule: 'getStringInteger64Rule',
            stringInteger64NotNullRule: 'getStringInteger64NotNullRule'
        }),
        ...mapGetters('global/actionsource', { dataSource: 'getDataSource', isNew: 'isDataSourceNewRecord' }),
        calculationTypes() {
            return [
                { id: 1, Name: "Сложение значений показателя в периодах" },
                { id: 2, Name: "Абсолютные значения показателя в периодах" }
            ];
        },
        scales() {
            return [
                { id: 0, Name: "Целое число (0)" },
                { id: 1, Name: "Один знак после запятой (0,0)" },
                { id: 2, Name: "Два знака после запятой (0,00)" },
                { id: 3, Name: "Три знака после запятой (0,000)" }
            ];
        },
        isViewMode() {
            return this.dataSource?.Data?.FormId == "2401021";
        },
        indicator() {
            return this.dataSource?.Data?.Object;
        },
        availableParentIndicators() {
            let values = [{ Id: '00000000-0000-0000-0000-000000000000', Name: this.$t("Отсутствует") }].concat(this.dataSource?.Data?.AdditionalObjects?.[1] ?? []);

            if (!this.indicatorsSearch)
                return values;

            return values.filter(i => sys.checkSearch(i.Name, this.indicatorsSearch) || i.Id == this.indicator.ParentId);                
        },
        pages() {
            let pages = 
            [
                { Count: -1, FormId: this.indicator.id, Name: this.$t("Показатель") },
                { Count: -1, FormId: 'Periods', Name: this.$t("Периоды") },
            ];

            return pages;
        },
        valuesMask() {
            var source = "#*";

            if (this.indicator.Scale == 0)
                return source;

            source += ",";
            return source.padEnd(source.length + this.indicator.Scale, "#");
        },
        indicatorStartDate: {
            get: function() {
                if (this.indicator.StartDate)
                    return this.$moment(this.indicator.StartDate).format('YYYY-MM-DD');
                
                return this.indicator.StartDate;
            },
            set: function(newValue) {
                this.updateSource({ property: 'Data.Object.StartDate', value: `/Date(${Date.parse(newValue)})/` });
            }
        },
        indicatorTargetDate: {
            get: function() {
                if (this.indicator.TargetDate)
                    return this.$moment(this.indicator.TargetDate).format('YYYY-MM-DD');
                
                return this.indicator.TargetDate;
            },
            set: function(newValue) {
                this.updateSource({ property: 'Data.Object.TargetDate', value: `/Date(${Date.parse(newValue)})/` });
            }
        },
        availableMonths() {
            let result = [];

            if (!this.indicator?.StartDate || !this.indicator?.TargetDate)
                return result;

            let start = this.$moment(this.indicator.StartDate).toDate();
            let end = this.$moment(this.indicator.TargetDate).toDate();
            let current = new Date(start.getFullYear(), start.getMonth(), 1);

            while (current <= end) {
                result.push({ month: current.getMonth() + 1, year: current.getFullYear() });
                current.setMonth(current.getMonth() + 1);
            }

            return result;
        },
        months() {
            return [
                'Январь', 'Февраль', 'Март', 'Апрель', 
                'Май', 'Июнь', 'Июль', 'Август', 
                'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
            ]
        },
        datacollectionPlanFact() {
            let workingPeriods = this.allPeriods.filter(p => p.Plan > 0 && !p.Disabled);
            let factor = Math.pow(10, this.indicator.Scale);

            let currentPeriod = this.$moment().toDate().getMonth() + 1;

            let labels = ['Старт'];
            let planData = [ this.indicator.StartValue / factor ];
            let factData = [ this.indicator.StartValue / factor ];

            //let factFinishPredict = 0;

            for (let wp of workingPeriods) {
                labels.push(this.months[wp.Period - 1]);
            }

            if (this.indicator.CalculationType === 1) {
                let tmpPlan = workingPeriods.reduce((acc, cv) => {
                    acc.push((acc[acc.length - 1] ?? (this.indicator.StartValue / factor)) + (cv.Plan / factor));
                    return acc;
                }, []);

                let tmpFact = workingPeriods.filter(wp => wp.Period < currentPeriod).reduce((acc, cv) => {
                    acc.push((acc[acc.length - 1] ?? (this.indicator.StartValue / factor)) + (cv.Fact / factor));
                    return acc;
                }, []);
                
                planData = planData.concat(tmpPlan);
                factData = factData.concat(tmpFact);
                //factFinishPredict = workingPeriods.reduce((acc, cv) => acc + (cv.Fact / factor), (this.indicator.StartValue / factor));
            }
            else {
                planData = planData.concat(workingPeriods.map(p => p.Plan / factor));
                factData = factData.concat(workingPeriods.filter(wp => wp.Period < currentPeriod).map(p => p.Fact / factor));
                //factFinishPredict = factData[factData.length - 1];
            }

            //planData.push(this.indicator.TargetValue / factor);
            //factData.push(factFinishPredict);
            //labels.push('Финиш');

            let targetValueDataSet = {
                label: 'Планируемое значение',
                borderColor: '#2E7D32',
                borderWidth: 1,
                borderDash: [10, 10],
                backgroundColor: 'transparent',
                data: planData.map(() => this.indicator.TargetValue / factor),
                fill: true,
                pointRadius: 0,
                tension: 0.1
            };

            let result = {
                labels,
                datasets: [
                    {
                        label: 'План',
                        borderColor: '#36a2eb', // Синий
                        backgroundColor: 'transparent',
                        data: planData,
                        fill: true,
                        borderDash: [5, 5], // Пунктирная линия для плана
                        tension: 0.1
                    },
                    {
                        label: 'Факт',
                        borderColor: '#EF5350', // Зеленый
                        backgroundColor: 'rgba(65, 184, 131, 0.1)', // Легкая заливка
                        data: factData,
                        fill: true,
                        pointRadius: 5,
                        pointHoverRadius: 7,
                        tension: 0.1
                    }
                ] 
            }

            if (!this.indicator.IsPlanAutoCalculated || this.indicator.CalculationType !== 2)
                result.datasets.push(targetValueDataSet);

            return result;
        },
        targetWithPlanPeriodsCompare() {
            let workingPeriods = this.allPeriods.filter(p => p.Plan > 0 && !p.Disabled);
            let periodsTargetValue = null;

            if (this.indicator.CalculationType === 1) {
                periodsTargetValue = workingPeriods.reduce((acc, cv) => acc + cv.Plan, this.indicator.StartValue);
            }
            else {
                periodsTargetValue = workingPeriods[workingPeriods.length - 1].Plan;
            }

            return (periodsTargetValue > this.indicator.TargetValue) - (periodsTargetValue < this.indicator.TargetValue);
        }
    },
    data() {
        return {
            tab: null,

            indicatorsSearch: null,

            startDateMenu: false,
            targetDateMenu: false,

            allPeriods: [],
            
            chartOptionsPlanFact: {
                responsive: true,
                layout: {
                    padding: {
                        top: 10,
                        bottom: 0,
                        left: 0,
                        right: 0
                    }
                },
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            padding: 10,
                            fontFamily: 'RobotoRegular',
                            fontSize: 12
                        },
                        gridLines: {
                            color: 'rgba(0, 0, 0, 0.05)'
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false // Скрываем вертикальные линии для чистоты
                        },
                        ticks: {
                            fontFamily: 'RobotoRegular',
                            fontSize: 12  
                        }
                    }]
                },
                plugins: {
                    datalabels: {
                        align: 'top',
                        offset: 5,
                        font: {
                            family: 'RobotoRegular',
                            weight: 'bold',
                            size: 12
                        },
                        // Отображаем метки только для "Факта" для экономии места
                        display: (ctx) => ctx.datasetIndex === 1, 
                        formatter: (value) => value
                    }
                },
                legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                        usePointStyle: false,
                        padding: 15,
                        fontFamily: 'RobotoRegular',
                        boxWidth: 12,
                        fontSize: 12
                    }
                    }
            },
        }
    },
    methods: {
        ...mapActions('global/actionsource', { updateSource: 'updateDataSource' }),
        update: _.debounce(function (object) { this.updateSource(object); }, 400),
        updateUnmaskedValue: _.debounce(function (property, event) {
            let value = parseFloat(event.target.value.replace(',', '.'));

            if (isNaN(value))
                value = 0;

            this.updateSource({ property, value: value * Math.pow(10, this.indicator.Scale) });
        }, 400),
        updatePeriodUnmaskedValue: _.debounce(function (index, property, event) {
            let value = parseFloat(event.target.value.replace(',', '.'));

            if (isNaN(value))
                value = 0;

            this.allPeriods[index][property] = value * Math.pow(10, this.indicator.Scale);
        }, 800),
        onTabClicked () { },
        async onToolbarClick (event, button) {
            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('global/actionsource/')).map(i => {return i.split('/')[2]})
            
            if (!actions.includes(button.Action)) {
                this.$notify.alert(`Действие_${button.Action}_не_реализовано.`);
                return;
            }

            if (['Save', 'SaveAndClose'].includes(button.Action)) {
                let validate_result = this.$refs.form1[0].validate() && (this.$refs.form2?.[0]?.validate() ?? true);

                if (!validate_result) {
                    this.$notify.alert(this.$t("Не_заполнены_обязательные_поля"));
                    return;
                }

                if (this.targetWithPlanPeriodsCompare != 0) {
                    let message = this.targetWithPlanPeriodsCompare > 0 ? "Планируемое значение индикатора превышено" : "Планируемое значение индикатора не достигнуто";
                    this.$notify.alert(this.$t(message));
                    this.tab = 1;
                    return;
                }

                let additionalObject = this.allPeriods.filter(p => p.Plan > 0 && !p.Disabled);
                this.updateSource({ property: 'Data.AdditionalObjects.[0]', value: additionalObject });
            }

            await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
        },
        getViewValueByMask(v) {
            let tmp = v / Math.pow(10, this.indicator.Scale);
            return tmp.toFixed(this.indicator.Scale).replace('.', ',');
        },
        updatePeriods(months) {
            if (!this.indicator) {
                this.allPeriods = [];
                return;
            }

            let periods = [];
            let year = this.$moment().toDate().getFullYear();
            let savedPeriods = this.dataSource?.Data?.AdditionalObjects?.[0] ?? [];            

            for (let i = 1; i <= 12; i++) {
                let period = savedPeriods.find(x => x.Year == year && x.Period == i);
                let tmpPeriod = this.allPeriods.find(x => x.Year == year && x.Period == i);

                if (!period) {
                    period = {
                        __type: "IndicatorValue:#Avrora.Objects.Modules.Indicators",
                        is_new_record: true,
                        IndicatorId: this.indicator.id,
                        Year: year,
                        Period: i,
                        Plan: tmpPeriod?.Plan ?? 0,
                        PlanDate: `/Date(${this.$moment().valueOf()})/`,
                        PlanAuthorId: this.$store.getters['global/auth/getUserInfo']?.EmployeeId,
                        Fact: 0,
                        FactDate: null
                    }
                }

                period.Disabled = !months.some(m => m.month == i && m.year == year);
                periods.push(period);
            }

            if (this.indicator.IsPlanAutoCalculated) {
                let activePeriodCount = periods.filter(p => !p.Disabled).length || 1;

                let total = this.indicator.TargetValue - this.indicator.StartValue;
                let base = Math.floor(total / activePeriodCount);
                let remainder = total % activePeriodCount;

                // let accumulated = this.indicator.StartValue;

                periods.forEach(p => {
                    if (p.Disabled) {
                        p.Plan = 0;
                        return;
                    }

                    if (this.indicator.CalculationType === 1) {
                        p.Plan = base + (remainder-- > 0 ? 1 : 0);
                    }
                    else {
                        // accumulated += base + (remainder-- > 0 ? 1 : 0);
                        // p.Plan = accumulated;

                        p.Plan = this.indicator.TargetValue;
                    }
                })
            }
            
            this.allPeriods = periods;
        }
    },
    watch: {
        isViewMode: {
            handler: function() {
                this.tab = 0;
            }
        },
        'indicator.Scale': {
            handler: function(nV, oV) {
                let diff = nV - oV;

                if (isNaN(diff))
                    return;
                
                let factor = Math.pow(10, diff);

                this.updateSource({ property: 'Data.Object.StartValue', value: Math.round(this.indicator.StartValue * factor) });
                this.updateSource({ property: 'Data.Object.TargetValue', value: Math.round(this.indicator.TargetValue * factor) });
                this.updateSource({ property: 'Data.Object.CurrentValue', value: Math.round(this.indicator.CurrentValue * factor) });

                this.allPeriods.forEach(p => {
                    p.Plan = Math.round(p.Plan * factor);
                    p.Fact = Math.round(p.Fact * factor);
                });

                if (this.indicator.IsPlanAutoCalculated)
                    this.updatePeriods(this.availableMonths);
            }
        },
        'indicator.IsPlanAutoCalculated': {
            handler: function() {
                this.updatePeriods(this.availableMonths);
            }
        },
        'indicator.CalculationType': {
            handler: function() {
                if (this.indicator.IsPlanAutoCalculated)
                    this.updatePeriods(this.availableMonths);
            }
        },
        'indicator.StartValue': {
            handler: function(startValue) {
                if (this.indicator.TargetValue < startValue && this.indicator.CalculationType === 1) {
                    this.updateSource({ property: 'Data.Object.CalculationType', value: 2 });
                    return;
                }

                if (this.indicator.IsPlanAutoCalculated)
                    this.updatePeriods(this.availableMonths);
            }
        },
        'indicator.TargetValue': {
            handler: function(targetValue) {
                if (this.indicator.StartValue > targetValue && this.indicator.CalculationType === 1) {
                    this.updateSource({ property: 'Data.Object.CalculationType', value: 2 });
                    return;
                }

                if (this.indicator.IsPlanAutoCalculated)
                    this.updatePeriods(this.availableMonths);
            }
        },
        availableMonths: {
            handler: function(months) {
                this.updatePeriods(months);
            },
            immediate: true
        }
    },
    async created() {
        (async() => {
            while(typeof this.$refs.form1 === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs?.form1?.[0]?.validate();
        })();
    },
    updated() {
        if (this.dataSource !== null) {
            this.$refs?.form1?.[0]?.validate();
            this.$refs?.form2?.[0]?.validate();
        }  
    }
}
</script>